import { formatDuration } from 'utils'

const units = { seconds: true, minutes: true, hours: true, days: true, years: true } as const

/**
 * Formats a `contentLifecyclePolicy.deleteAfter` (seconds) for display.
 *
 * Returns `null` when there is no policy, so callers pick their own "no expiry" copy —
 * the stream columns keep their per-kind wording while the General tab uses its own.
 */
export const formatContentLifecycleDuration = (deleteAfter?: number) => {
  const seconds = deleteAfter ? parseInt(deleteAfter.toFixed(0)) : null

  if (!seconds) {
    return null
  }

  return {
    /** Largest unit only, long form — e.g. "7 days". For the summary label. */
    label: formatDuration(seconds, units, { suffixed: true, longSuffix: true, omitEmptyValues: true })[0] as string,
    /** All non-empty units joined — e.g. "7d 12h". For the explanatory sentence. */
    full: (formatDuration(seconds, units, { suffixed: true, omitEmptyValues: true }) as string[]).join(' '),
  }
}
